export default __webpack_public_path__ + "static/media/multi-pitch.e7c44ec6.png";